/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TicketResendRequest
 */
export interface TicketResendRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketResendRequest
     */
    email: string | null;
}

/**
 * Check if a given object implements the TicketResendRequest interface.
 */
export function instanceOfTicketResendRequest(value: object): value is TicketResendRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function TicketResendRequestFromJSON(json: any): TicketResendRequest {
    return TicketResendRequestFromJSONTyped(json, false);
}

export function TicketResendRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketResendRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function TicketResendRequestToJSON(json: any): TicketResendRequest {
    return TicketResendRequestToJSONTyped(json, false);
}

export function TicketResendRequestToJSONTyped(value?: TicketResendRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

